import type { TeacherBrand } from '@/component/molecules/SubjectSwitch/subjectMenu'

/**
 * 영어 진입 모달 문구. 브랜드별로 **문장 전문**을 둔다.
 *
 * 서비스명만 끼워 넣으면 조사가 깨진다 — "잉글리시플랫은" / "스쿨플랫 영어는" 처럼
 * 받침 유무로 은/는이 갈리고, 스쿨플랫은 B2G 라 "무료" 를 말하지 않는다
 * (사이언스플랫도 스쿨플랫 문구에서 무료 표현을 뺀다).
 */
type ServiceEntryCopy = {
  consentTitle: string
  /** 앞 문장. `무료로` 강조가 들어가는 자리는 leadEmphasis 로 나눠 둔다. */
  consentLeadBefore: string
  consentLeadEmphasis?: string
  consentLeadAfter: string
  consentQuestion: string
  adminLead: string
  adminSteps: [string, string]
  doneTitle: string
  doneLead: string
  doneAccount: string
  dupeTitle: string
  dupeLead: string
  dupeQuestion: string
  /** 서비스명이 들어가는 안내. 나머지 실패 문구는 서비스와 무관해 아래 상수로 공유한다. */
  loginBlocked: string
  entitlementRequired: string
}

export const SERVICE_ENTRY_COPY: Record<TeacherBrand, ServiceEntryCopy> = {
  mathflat: {
    consentTitle: '잉글리시플랫 이용하기',
    consentLeadBefore: '매쓰플랫 선생님은 잉글리시플랫을 ',
    consentLeadEmphasis: '무료로',
    consentLeadAfter: ' 이용하실 수 있습니다.',
    consentQuestion: '쓰시던 계정 그대로 지금 바로 신청하시겠습니까?',
    adminLead: '잉글리시플랫은 관리자 선생님 계정으로 신청할 수 있습니다.',
    adminSteps: [
      '관리자 선생님 계정으로 잉글리시플랫 이용 신청',
      '잉글리시플랫 ‘선생님 관리’에서 선생님별 과목 권한 설정',
    ],
    doneTitle: '신청이 완료되었습니다',
    doneLead: '이제 잉글리시플랫을 이용하실 수 있습니다.',
    doneAccount: '매쓰플랫에서 쓰시던 계정 그대로 로그인됩니다.',
    dupeTitle: '이미 신청하셨습니다',
    dupeLead: '잉글리시플랫을 바로 이용하실 수 있습니다.',
    dupeQuestion: '지금 이동하시겠습니까?',
    loginBlocked: '잉글리시플랫은 해당 계정에서 이용하실 수 없습니다.',
    entitlementRequired: '잉글리시플랫 이용 기간이 만료되었습니다. 관리자 선생님께 문의해 주세요.',
  },
  schoolflat: {
    consentTitle: '스쿨플랫 영어 이용하기',
    consentLeadBefore: '스쿨플랫 영어 과목을 처음 이용하실 때 한 번의 신청이 필요합니다.',
    consentLeadAfter: '',
    consentQuestion: '쓰시던 계정 그대로 지금 바로 신청하시겠습니까?',
    adminLead: '스쿨플랫 영어는 관리자 선생님 계정으로 신청할 수 있습니다.',
    adminSteps: [
      '관리자 선생님 계정으로 스쿨플랫 영어 이용 신청',
      '스쿨플랫 영어 ‘선생님 관리’에서 선생님별 과목 권한 설정',
    ],
    doneTitle: '신청이 완료되었습니다',
    doneLead: '이제 스쿨플랫 영어를 이용하실 수 있습니다.',
    doneAccount: '스쿨플랫에서 쓰시던 계정 그대로 로그인됩니다.',
    dupeTitle: '이미 신청하셨습니다',
    dupeLead: '스쿨플랫 영어를 바로 이용하실 수 있습니다.',
    dupeQuestion: '지금 이동하시겠습니까?',
    loginBlocked: '스쿨플랫 영어는 해당 계정에서 이용하실 수 없습니다.',
    entitlementRequired: '스쿨플랫 영어 이용 기간이 만료되었습니다. 관리자 선생님께 문의해 주세요.',
  },
}

/** 서비스명이 들어가지 않아 브랜드와 무관한 안내. */
export const SERVICE_ENTRY_NOTICE = {
  /** 권한은 켜졌다가 이용권 지급이 실패해 되돌려진 상태 - 재시도가 실제로 유효하다. */
  grantFailed: '신청 처리 중 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.',
  unavailable: '일시적인 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
}
